// bully ignore[service-no-react-imports: the use<Name>Service DI hook lives in service/index.ts by repo convention (every sibling feature; client/AGENTS.md documents this exact shape) — the service class in service.ts stays react-free; permanent: rule/convention tension until the DI-hook file gets a carve-out]
import { useMemo } from 'react'

// bully ignore[no-yogi-api-client-import: useApiClient IS the injection seam this rule protects — every sibling service/index.ts obtains the client this way (all baselined) and no compliant runtime path to the client exists for a new file; permanent: rule miscalibration for the DI hook itself, no-cross-feature-barrel-imports: 'clients/yogi-api' is the client package's public entry; any deeper path still contains 'yogi-api' and trips no-yogi-api-client-import the same way; permanent: same miscalibration]
import { useApiClient } from 'clients/yogi-api'
import { AccountsService } from 'features/accounts/service/service'

export { AccountsService } from 'features/accounts/service/service'
export type {
  CreateAccountGroupInput,
  CreateAccountInput,
} from 'features/accounts/service/service'

export function useAccountsService(): AccountsService {
  const client = useApiClient()
  return useMemo(() => new AccountsService(client), [client])
}
